const VERSION = {
  frontend: '7.5.0',
};

export default VERSION;
